import StudyPlanTask from "components/pages/tarefas/study_plan_task";
import { task as taskFixture } from "./fixtures";

import clsx from "clsx";

type StudyPlanTaskGroupProps = {
  groupKey: string;
  tasks: any[];
  isLoading: boolean;
  opacity?: string;
};

export default function StudyPlanTaskGroup(
  props: StudyPlanTaskGroupProps
): JSX.Element {
  const { groupKey, opacity, isLoading } = props;
  const tasks = props.tasks || [];

  const labels = {
    current: "Tarefa atual",
    next: "Tarefas pendentes",
    ignored: "Tarefas ignoradas",
    completed: "Tarefas concluídas"
  };

  const fixtureCount = {
    current: 1,
    next: 5,
    completed: 2
  };

  return (
    <section className={clsx("tasks-wrapper", groupKey)}>
      <span className="block mb-4 ml-2 w-full text-center text-emphasis-medium text-lg tracking-wider uppercase md:text-left">
        {labels[groupKey]}
      </span>

      <div className="tasks flex flex-col flex-wrap md:flex-row">
        {!isLoading &&
          ((tasks.length > 0 &&
            tasks.map((task) => (
              <div
                key={`${task.topic.parent.slug} - ${task.topic.slug}`}
                className="mb-5 md:mb-2 md:p-2 md:w-1/3"
              >
                <StudyPlanTask
                  task={task}
                  isLoading={false}
                  opacity={opacity}
                />
              </div>
            ))) || (
            <span>Nenhuma tarefa dessa etapa faz parte desse grupo.</span>
          ))}

        {isLoading &&
          Array.from(Array(fixtureCount[groupKey])).map((task, index) => (
            <div
              key={`${groupKey} - ${index}`}
              className={clsx(
                "mb-5 hover:opacity-100 transition-opacity md:mb-2 md:p-2 md:w-1/3",
                opacity
              )}
            >
              <StudyPlanTask task={taskFixture} isLoading={true} />
            </div>
          ))}
      </div>
    </section>
  );
}
